import React from 'react';
import PropTypes from 'prop-types';
import DrawerAnchor from '../../UI/DrawerAnchor';
import ShelfSelect from './ShelfSelect';

export default class ShelfSelectDrawer extends React.Component {
	static propTypes = {
		sku: PropTypes.string,
		children: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
		parentStyle: PropTypes.string,
		// Mapped to props
		isMobile: PropTypes.func,
	};

	static defaultProps = {
		parentStyle: 'clickable dotDot',
	};

	render() {
		const { parentStyle } = this.props;
		return (
			<DrawerAnchor
				closable={true}
				placement="top"
				height="280"
				parentStyle={parentStyle}
				renderDrawerContent={this.renderDrawerContent}>
				{this.props.children}
			</DrawerAnchor>
		);
	}

	renderDrawerContent = drawer => {
		return drawer.isVisible && this.renderShelfSelect();
	};

	renderShelfSelect = () => {
		const { skus, sku } = this.props;
		return <ShelfSelect skus={skus} sku={sku} />;
	};
}
